import { styled } from '@nykaa/ui-components';
import {
  MWEB_HEADER_ZINDEX,
  APP_MIGRATION_TOP_BANNER_HEIGHT,
} from 'shared/styles/base';

export const StickyHeaderWrapper = styled.div<{ hasBanner: boolean }>`
  position: sticky;
  top: ${({ hasBanner }) =>
    hasBanner
      ? `calc(-${APP_MIGRATION_TOP_BANNER_HEIGHT}px - env(safe-area-inset-top, 0px))`
      : '0px'};
  z-index: ${MWEB_HEADER_ZINDEX};
`;

export const Container = styled.div<{
  allowPadding: boolean;
  isRewardsPageEnabled: boolean;
}>``;
